export default __webpack_public_path__ + "static/media/yahtzee.b794ca7f.PNG";